import { render, staticRenderFns } from "./PrivacyPolicyContent.vue?vue&type=template&id=e5beddde&"
import script from "./PrivacyPolicyContent.vue?vue&type=script&lang=js&"
export * from "./PrivacyPolicyContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports